module.exports = __webpack_public_path__ + "img/about_06.3a134feb.png";